import { render, staticRenderFns } from "./tab-inactive.vue?vue&type=template&id=681a583c&scoped=true"
import script from "./tab-inactive.vue?vue&type=script&lang=js"
export * from "./tab-inactive.vue?vue&type=script&lang=js"
import style0 from "./tab-inactive.vue?vue&type=style&index=0&id=681a583c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681a583c",
  null
  
)

export default component.exports